import { render, staticRenderFns } from "./NotificationActivityTable.vue?vue&type=template&id=d2a6579e&scoped=true"
import script from "./NotificationActivityTable.vue?vue&type=script&lang=js"
export * from "./NotificationActivityTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationActivityTable.vue?vue&type=style&index=0&id=d2a6579e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a6579e",
  null
  
)

export default component.exports